export default "__VITE_ASSET__bAqdHKP_xRyIHOmkTRuOfQ__"